import AVAILABLE_ENVIRONMENTS from '../config';

export { AVAILABLE_ENVIRONMENTS as environments };

const env = {
  ...process.env,
  // eslint-disable-next-line dot-notation
  ...(AVAILABLE_ENVIRONMENTS['__RUNTIME_ENV__'] ||
    AVAILABLE_ENVIRONMENTS.development),
};

// Default REGION to 'vi' if not set
if (!env.REGION) {
  env.REGION = 'vi';
}

export default env;
